import { useState } from 'react';
import { connect } from 'react-redux';
import {
  TextField,
  Autocomplete,
  DialogTitle,
  Dialog,
  DialogContent,
  DialogActions,
  Button,
} from '@mui/material';

const EquipmentSelectorDialog = ({
  onSubmit,
  onCancel,

  open,
  equipment,
}) => {
  const [selected, setSelected] = useState();
  return (
    <Dialog open={open} fullWidth>
      <DialogTitle>Select Equipment</DialogTitle>
      <form
        onSubmit={(event) => {
          event.preventDefault();
          onSubmit(selected);
        }}
        onReset={onCancel}
        id="equipmentSelect"
      >
        <DialogContent>
          <Autocomplete
            options={equipment}
            onChange={(_event, { equipId }) => setSelected(equipId)}
            getOptionLabel={(e) => `${e.name} - ${e.equipmentType?.nameAbbr}`}
            value={selected}
            // eslint-disable-next-line react/jsx-props-no-spreading
            renderInput={(params) => <TextField label="Select Equipment" {...params} />}
          />
        </DialogContent>
        <DialogActions>
          <Button type="reset" form="equipmentSelect">
            Cancel
          </Button>
          <Button variant="contained" color="success" type="submit" form="equipmentSelect">
            Submit
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default connect()(EquipmentSelectorDialog);
